import { Button } from '@/components/atoms/Button';
import { DividerCard, DividerCardBody, DividerCardTitle } from '@/components/atoms/DividerCard';
import React, { useMemo, useState } from 'react';
import FavoriteCompetitorsModal from '../FavoriteCompetitorsModal/FavoriteCompetitorsModal';
import { useAuthCookies } from '@/hooks/useAuthCookies';
import LivescoreSkeleton from '../LivescoreSkeleton/LivescoreSkeleton';
import { CompetitorElement } from '@/components/atoms/CompetitorElement';
import { useLivescoreLayout } from '@/context/LivescoreLayoutContext';

const FavoriteCompetitorsCard = () => {
  const { token } = useAuthCookies();

  if (!token) return null;

  const {
    favoriteCompetitors,
    teams,
    teamsLoading: loading,
    favoriteCompetitorsModalOpen,
    setFavoriteCompetitorsModalOpen,
  } = useLivescoreLayout();

  const favoriteTeams = useMemo(
    () => teams.filter((team) => favoriteCompetitors.has(team.id)),
    [teams, favoriteCompetitors],
  );

  return (
    <>
      <DividerCard>
        <DividerCardTitle>Moje drużyny</DividerCardTitle>
        <DividerCardBody>
          {favoriteTeams.length > 0 && (
            <ul className="list-none px-0 mb-4">
              {loading ? (
                <LivescoreSkeleton items={2} className="!w-full relative z-50 h-[58px]" />
              ) : (
                favoriteTeams.map((team) => (
                  <li key={team.id} className="animate-fade-in">
                    <CompetitorElement team={team} icon="x" size="small" addLink />
                  </li>
                ))
              )}
            </ul>
          )}
          <Button
            variant="outlined"
            className="w-full !text-xxs font-bold !border-primary-600 rounded-lg hover:bg-primary-600 hover:text-black-400 text-black dark:text-white transition-colors"
            onClick={() => setFavoriteCompetitorsModalOpen(true)}
          >
            Dodaj swoją drużynę
          </Button>
        </DividerCardBody>
      </DividerCard>
      <FavoriteCompetitorsModal
        isOpen={favoriteCompetitorsModalOpen}
        variant={'default'}
        closeModal={() => setFavoriteCompetitorsModalOpen(false)}
        allTeams={teams}
        loading={loading}
      />
    </>
  );
};

export default FavoriteCompetitorsCard;
